import { render, staticRenderFns } from "./AbandonmentsListComponent.vue?vue&type=template&id=10aaffae&scoped=true&"
import script from "./AbandonmentsListComponent.vue?vue&type=script&lang=js&"
export * from "./AbandonmentsListComponent.vue?vue&type=script&lang=js&"
import style0 from "./AbandonmentsListComponent.vue?vue&type=style&index=0&id=10aaffae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10aaffae",
  null
  
)

export default component.exports